import { ToggleSwitch } from "@abb/abb-common-ux-react/components/ToggleSwitch";
import styled from "styled-components";

export const StyledSwitch = styled(ToggleSwitch)`
  .ABB_CommonUX_ToggleSwitch__control:after {
    content: "" !important;
  }
`;
